import CombinedPreferencesRow from './CombinedPreferencesRow'

export default CombinedPreferencesRow